import React, {FC, useEffect, useState} from 'react';

import path_up from 'assets/images/closeSelectIcon.svg';
import path_down from 'assets/images/openSelectIcon.svg';
import iconStateDisabled from "assets/icons/commons/source-state-disabled.svg"
import iconStateSuccess from "assets/icons/commons/source-state-active.svg"
import iconStateError from "assets/icons/commons/source-state-error.svg"
import ToggleButton from "../../ToggleButton";
import {DataSource} from "../../../../constants/DataSource/DataSource";
import {DataSourceStatus} from "../../../../constants/DataSource/DataSourceStatus";
import {t} from "i18next";
import Input from "../../../commons/Input/Input";
import FormSelect, {ISelectOption} from "../../../commons/Select/FormSelect";
import {v4 as uuidv4} from "uuid";
import classNames from "classnames";
import {FrequencySelector} from "../../FrequencySelector";
import {RuleRow, StockConvertRule} from "./RuleRow";
import {Button} from "../../../buttons";
import plus from "../../../../assets/icons/commons/roundPlus.svg";

const initialStockConvertRule: StockConvertRule = {
  contains: '',
  operator: '=',
  count: 0,
}

interface DataSourceProps {
  code: string
  data: DataSource|null
  updateDataSourceHandler: (code: string, payload: DataSource|null) => void
  toggleIsDisclosed: (code: string) => void
  toggleItemStatus: (code: string, isActive: boolean) => void
  isDisclosed: boolean
  isActive: boolean
}

export const Levenhuk: FC<DataSourceProps> = ({
  code,
  data,
  updateDataSourceHandler,
  toggleIsDisclosed,
  toggleItemStatus,
  isDisclosed,
  isActive
}) => {

  const title = 'Levenhuk-opt.ru'

  const onStatusChange = (isActiveStatus: boolean) => {
    isActive = isActiveStatus
    toggleItemStatus(code, isActiveStatus)
  };

  // Param - frequency
  const onUpdateFrequencyChange = (frequency: number) => {
    setUpdateFrequency(frequency)
  };
  const [updateFrequency, setUpdateFrequency] = useState(0);

  // Param - identity field in source
  const availableSkuFieldIds: {[key: string]: string} = {
    "code": "code",
    "ean": "ean",
  }
  const defaultSkuFieldId = "code"
  const [skuFieldId, setSkuFieldId] = useState(defaultSkuFieldId);
  const [skuFieldIdSelectorOptions, setSkuFieldIdSelectorOptions] = useState<ISelectOption[]>([]);

  // Param - internal identity field
  const availableMapByOptions: {[key: string]: string} = {
    "sku": "Артикул",
    "barcode": "Штрих-код"
  }
  const defaultMapBy = "sku"
  const [mapBy, setMapBy] = useState(defaultMapBy);
  const [mapBySelectorOptions, setMapBySelectorOptions] = useState<ISelectOption[]>([]);
  const [stockFieldId, setStockFieldId] = useState<string>('');

  // Param - stock convert rules
  const [stockConvertRules, setStockConvertRules] = useState<StockConvertRule[]>([]);

  const [errors, setErrors] = useState({stockFieldId: ''});

  // @ts-ignore
  const fieldsWithErrors = Object.keys(errors).filter((k: string) => errors[k].length > 0)
  const isFormHasErrors = fieldsWithErrors.length > 0
  const state = isActive ? (isFormHasErrors ? 'fail' : 'success') : 'disabled'
  const dataSourceStateIconAssets = {
    'disabled': iconStateDisabled,
    'success': iconStateSuccess,
    'fail': iconStateError
  }

  useEffect(() => {
    const skuFieldIdSelectOptions: ISelectOption[] = []
    for (const key in availableSkuFieldIds) {
      skuFieldIdSelectOptions.push({text: availableSkuFieldIds[key], value: key})
    }
    setSkuFieldIdSelectorOptions(skuFieldIdSelectOptions)


    const mapBySelectOptions: ISelectOption[] = []
    for (const key in availableMapByOptions) {
      mapBySelectOptions.push({text: availableMapByOptions[key], value: key})
    }
    setMapBySelectorOptions(mapBySelectOptions)
  }, [])

  useEffect(() => {
    console.log('LEVENHUK useEffect - data', data)

    if (!data) {
      toggleItemStatus(code, false)
    }

    // @ts-ignore
    setSkuFieldId(data?.configMap.skuFieldId || defaultSkuFieldId)
    // @ts-ignore
    setMapBy(data?.configMap.mapBy || defaultMapBy)
    // @ts-ignore
    setStockFieldId(data?.configMap.stockFieldId || null)

    setUpdateFrequency(data?.updateFrequency || 0)

    // @ts-ignore
    setStockConvertRules(data?.configMap?.stockConvertRules?.length > 0 ? JSON.parse(data?.configMap?.stockConvertRules) : [initialStockConvertRule])

  }, [data])

  useEffect(() => {
    console.log('useEffect - updateFrequency, status')

    if (!data && (isActive)) {
      data = {
        uuid: uuidv4(),
        code: code,
        configMap: {},
        name: title,
        status: isActive ? DataSourceStatus.Current : DataSourceStatus.Archived,
        updateFrequency: 0,
      }
      console.log('XML set initial data', data)
    }

    if (data) {
      data.updateFrequency = updateFrequency
      const rr = stockConvertRules.filter(v => ['isN', 'isNaN'].includes(v.operator) || v.contains.length > 0)
      data.configMap = {
        skuFieldId: skuFieldId,
        mapBy: mapBy,
        stockFieldId: stockFieldId,
        stockConvertRules: JSON.stringify(rr),
      }
      updateDataSourceHandler(code, data)
      console.log('updateDataSourceHandler', data)
    }

    console.log('LEVENHUK! data', data)

  }, [skuFieldId, mapBy, updateFrequency, isActive, stockFieldId, stockConvertRules])

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  function updateFrequencyHandler(e: any): void {
    setUpdateFrequency(parseInt(e.target.value))
  }

  function setStockConvertRulesDecorator(rr: StockConvertRule[]) {
    setStockConvertRules(rr)
  }

  function deleteStockConvertRule(position: number) {
    if (position === 0 && stockConvertRules.length === 1) {
      setStockConvertRulesDecorator([initialStockConvertRule])
    } else {
      setStockConvertRulesDecorator(stockConvertRules.filter((_, i) => i !== position))
    }
  }

  function updateStockConvertRules(position: number, data: StockConvertRule) {
    if (position === 0 && stockConvertRules.length === 1) {
      setStockConvertRulesDecorator([data])
    } else {
      setStockConvertRulesDecorator(stockConvertRules.map((v, i) => i === position ? {...data} : v))
    }
  }

  return (
      <div
          className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
      >
        <div className="flex max-h-11 rounded items-center justify-between" onClick={() => toggleIsDisclosed(code)}>
          <div className="flex items-center min-w-36">
            <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
              <img src={dataSourceStateIconAssets[state]} className="mr-2" />
              {title}
            </div>
          </div>
          <div className="flex items-center">
            <ToggleButton
                label="Подключен"
                labelId="название-опции-тут"
                onChange={onStatusChange}
                isChecked={isActive}
            />
            <div>
              <div>
                <img src={isDisclosed ? path_up : path_down} alt={''} />
              </div>
            </div>
          </div>

        </div>
        {isDisclosed && (
            <div className={'mt-4'}>
              <div>
                Сопоставить по значению
              </div>
              <div className="mt-4 flex flex-row">

                <div className={`w-1/2`}>
                  <FormSelect
                      id="levenhuk_mapBy"
                      name="levenhuk_mapBy"
                      value={mapBy}
                      label={t<string>("LK", { ns: "messages" })}
                      changeHandler={event => setMapBy(event.target.value)}
                      customClassName={classNames(customInputClassName)}
                      customLabelClassName="text-sm"
                      blurHandler={event => setMapBy(event.target.value)}
                      validationError={false}
                      validationErrorDescription={''}
                      options={mapBySelectorOptions}
                      require={false}
                  ></FormSelect>
                </div>
                <div className={`p-4 flex items-end`}>=</div>
                <div className={`w-1/2`}>
                  <FormSelect
                      id="levenhuk_skuFieldId"
                      name="levenhuk_skuFieldId"
                      value={skuFieldId}
                      label={t<string>("XML", { ns: "messages" })}
                      changeHandler={event => setSkuFieldId(event.target.value)}
                      customClassName={classNames(customInputClassName)}
                      customLabelClassName="text-sm"
                      blurHandler={event => setSkuFieldId(event.target.value)}
                      validationError={false}
                      validationErrorDescription={''}
                      options={skuFieldIdSelectorOptions}
                      require={false}
                  ></FormSelect>
                </div>

              </div>
              <div className="mt-4 flex flex-row">

                <div className={`w-1/2`}>
                  <Input
                      placeholder="stock_msk"
                      id="levenhuk_url"
                      name="levenhuk_url"
                      value={t<string>("Остаток", { ns: "messages" })}
                      label={null}
                      changeHandler={() => {}}
                      customClassName={customInputClassName}
                      customLabelClassName="text-sm"
                      readOnly={true}
                      type="text"
                      require={false}
                  />
                </div>
                <div className={`p-4 pt-2 flex items-end`}>=</div>
                <div className={`w-1/2`}>
                  <Input
                      placeholder="stock_msk"
                      id="levenhuk_url"
                      name="levenhuk_url"
                      value={stockFieldId}
                      label={null}
                      changeHandler={event => setStockFieldId(event.target.value)}
                      customClassName={customInputClassName}
                      customLabelClassName="text-sm"
                      blurHandler={event => setStockFieldId(event.target.value)}
                      validationError={errors.stockFieldId.length > 0}
                      validationErrorDescription={errors.stockFieldId}
                      type="text"
                      require={false}
                  />
                </div>

              </div>
              <div className="mt-4">
                Правила чтения остатков (приоритет правил - сверху-вниз)
              </div>
              <div className="mt-4">
                {stockConvertRules.map((r, k) =>
                    <RuleRow key={k} position={k} rulesCount={stockConvertRules.length} data={r} deleteRule={deleteStockConvertRule} updateDataHandler={updateStockConvertRules}></RuleRow>
                )}
                <div className={`text-right mt-4`}>
                  <Button
                      clickHandler={() => setStockConvertRules([...stockConvertRules, initialStockConvertRule])}
                      appearance="primary"
                      customClassName="button-add"
                      type="button"
                  >
                    <div className="flex justify-around w-[150px] items-center">
                      <img src={plus} alt="" className="w-4 h-4" />
                      <div>Добавить правило</div>
                    </div>
                  </Button>
                </div>
              </div>
              <div className="mt-4 flex justify-between">
                <div className={"w-5/12"}>
                  <FrequencySelector data={updateFrequency} onChange={onUpdateFrequencyChange}></FrequencySelector>
                </div>
                {data &&
                    <button
                        className="self-end items-center text-sm text-left font-medium mb-1 border-[1px] px-[15px] h-[42px] rounded mt-2 active:outline-none"
                        onClick={()=> {data = null; updateDataSourceHandler(code, data); console.log("DATA", data)}}
                        type={"button"}
                    >
                      Удалить источник
                    </button>
                }

              </div>

            </div>
        )}
      </div>
  );
};
